<div class="home-container">
    <div class="absolute top-4 right-4 z-10">
        <button mat-flat-button  class="bg-gray-300 hover:bg-gray-400  text-gray-800 p-4 py-1 rounded-md" (click)="openHelp()">Help</button>

    </div>
    <app-grid-layout-template [backgroundImageUrl]="bgImageUrl">
        <div class="flex flex-col gap-4 mt-8 w-full mx-auto">
            <div class="rounded flex justify-center items-center bg-white mb-2 py-2 font-semibold cursor-pointer"
                [routerLink]="[ '/vhs']" [auth]="uiAccessList.Vhs">
                <div class="flex-1 text-center">VHS LABORATORY</div>
                <div class="px-4">
                    <img src="/assets/images/landing-lab.svg" alt="Logo" class="h-8 w-8">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-2 py-2 font-semibold cursor-pointer"
                [routerLink]="[ '/radiology']" [auth]="uiAccessList.Radiology">
                <div class="flex-1 text-center">RADIOLOGY</div>
                <div class="px-4">
                    <img src="/assets/images/black Radiology icon.svg" alt="Logo" class="h-8 w-8">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-2 py-2 font-semibold cursor-pointer"
                [routerLink]="['/insurance']" [auth]="uiAccessList.Insurance">
                <div class="flex-1 text-center">ANALYZE CLAIMS</div>
                <div class="px-4">
                    <img src="/assets/images/insurance-home.svg" alt="Logo" class="h-8 w-8">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-2 py-2 font-semibold cursor-pointer"
                [routerLink]="[ '/document-scanner']"
                [auth]="[uiAccessList.DocumentScanner, uiAccessList.MedicalRecord, uiAccessList.SpecializedFeature]">
                <div class="flex-1 text-center">MEDICAL RECORD UPLOAD</div>
                <div class="px-4">
                    <img src="/assets/images/landing-upload.svg" alt="Logo" class="h-8 w-8">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-2 py-2 font-semibold cursor-pointer"
                [routerLink]="['/upload-report']" [auth]="uiAccessList.UploadReport">
                <div class="flex-1 text-center">UPLOAD REPORT</div>
                <div class="px-4">
                    <img src="/assets/images/landing-upload.svg" alt="Logo" class="h-8 w-8">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
                [routerLink]="['/report']" [auth]="uiAccessList.ManualEntry">
                <div class="flex-1 text-center text-primary">ENTER MANUALLY</div>
                <div class="px-4">
                    <img src="/assets/images/landing-manually.svg" alt="Logo" class="h-8 w-8">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
                [routerLink]="['/medical-record-analysis']" [auth]="uiAccessList.MedicalRecordAnalysis">
                <div class="flex-1 text-center">MEDICAL RECORD ANALYSIS</div>
                <div class="px-4">
                    <img src="/assets/images/emr-analysis.svg" alt="Logo" class="h-8 w-8 icon">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
                [routerLink]="['/medical-record-history']" [auth]="uiAccessList.MedicalRecordHistory">
                <div class="flex-1 text-center">MEDICAL RECORD HISTORY</div>
                <div class="px-4">
                    <img src="/assets/images/emr-history.svg" alt="Logo" class="h-8 w-8 icon">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
                [routerLink]="['/icd-code-analysis']" [auth]="uiAccessList.ICDCodeAnalysis">
                <div class="flex-1 text-center">ICD CODE ANALYSIS</div>
                <div class="px-4">
                    <img src="/assets/images/emr-analysis.svg" alt="Logo" class="h-8 w-8 icon">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
                [routerLink]="['/preauth']" [auth]="uiAccessList.PreAuth">
                <div class="flex-1 text-center text-black">PRE AUTH EXTRACTION</div>
                <div class="px-4">
                    <img src="/assets/images/textract-black-icon.svg" alt="Logo" class="h-8 w-8 filter invert-0">
                </div>
            </div>

            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
            [routerLink]="['/risk-score']" [auth]="uiAccessList.RiskScore">
            <div class="flex-1 text-center text-black">RISK SCORE</div>
            <div class="px-4">
                <img src="/assets/images/risk-meter.png" alt="Risk Score" class="h-8 w-8 filter invert-0">
            </div>
            </div>


            <div class="rounded flex justify-center items-center bg-white mb-4 py-2 font-semibold cursor-pointer"
            [routerLink]="[ '/extract-input']" [auth]="uiAccessList.ExtractInput">
            <div class="flex-1 text-center text-black">EXTRACT INPUT</div>
            <div class="px-4">
                <img src="/assets/images/extract-input.png" alt="Logo" class="h-8 w-8 icon">
            </div>
            </div>

            </div>
            <div>
            <div class="flex justify-around flex-wrap gap-x-2 gap-y-3">
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/dashboard']" [auth]="uiAccessList.Dashboard">
                    <img src="/assets/images/home.svg" alt="profile" class="w-5 h-5">
                    <div class="text-xs text-white">Dashboard</div>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/dashboard/insurance']" [auth]="uiAccessList.Insurance">
                    <img src="/assets/images/home.svg" alt="profile" class="w-5 h-5">
                    <div class="text-xs text-white">Claim Dashboard</div>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                [routerLink]="['/dashboard/icd']" [auth]="uiAccessList.IcdCodeHistory">
                <img src="/assets/images/home.svg" alt="profile" class="w-5 h-5">
                <div class="text-xs text-white">ICD Dashboard</div>
            </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/user/profile']" [auth]="uiAccessList.Profile">
                    <img src="/assets/images/landing-profile.svg" alt="profile" class="w-5 h-5">
                    <div class="text-xs text-white">Profile</div>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/old-reports']" [auth]="uiAccessList.OldReports">
                    <img src="/assets/images/landing-old-record.svg" alt="old reports" class="w-5 h-5">
                    <div class="text-xs text-white">Old Records</div>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/insurance-records']" [auth]="uiAccessList.ClaimHistory">
                    <img src="/assets/images/landing-old-record.svg" alt="old reports" class="w-5 h-5">
                    <div class="text-xs text-white">Claim History</div>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/prescription']" [auth]="uiAccessList.Prescriptions">
                    <img src="/assets/images/prescription.svg" alt="home" class="w-5 h-5">
                    <div class="text-xs text-white">Prescription</div>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center cursor-pointer"
                    [routerLink]="['/comparison']"
                    [auth]="[uiAccessList.ComparisonTable, uiAccessList.ReportComparison]">
                    <img src="/assets/images/compare.svg" alt="home" class="w-10 h-5">
                    <div class="text-xs text-white">Comparison</div>
                </div>
            </div>
        </div>
        <div class="flex justify-center items-center text-xs gap-2 text-white cursor-pointer" (click)="onLogOut()">
          Logout
          <img src="/assets/images/landing-logout.svg" alt="logout" class="w-5 h-5">
      </div>
    </app-grid-layout-template>
</div>
